import { Link } from "react-router-dom";

export const Logo = ({ testid = "league-logo", compact = false }) => (
  <Link to="/" data-testid={testid} className="group flex items-center gap-3" aria-label="Telangana–Andhra T10 League home">
    <svg viewBox="0 0 48 48" className="h-10 w-10 shrink-0" aria-hidden="true">
      <rect x="2" y="2" width="44" height="44" rx="6" fill="#0A192F" stroke="#00E5FF" strokeWidth="2" />
      <circle cx="35" cy="13" r="5" fill="#FF5722" />
      <path d="M30 13c-1.5 2-1.5 4 0 6" stroke="#0A192F" strokeWidth="1" fill="none" opacity=".6" />
      <text x="22" y="36" textAnchor="middle" fontFamily="Anton, Impact" fontSize="20" fill="#fff">T10</text>
    </svg>
    {!compact && (
      <span className="leading-none">
        <span className="block font-display text-lg uppercase tracking-wide text-white transition-colors group-hover:text-[#00E5FF]">TA T10 League</span>
        <span className="block text-[9px] font-bold uppercase tracking-[0.25em] text-slate-400">Telangana · Andhra</span>
      </span>
    )}
  </Link>
);
